const FADE_MS = 200

/**
 * Fade the current page out, then perform a full Turbo visit (not a frame
 * swap). Used for crossing between the main app and the WFI v2 shell, which
 * have entirely different chrome — a frame navigation would leave the old
 * sidebar on screen.
 */
export const fadeOutAndVisit = (path: string) => {
  const visit = () => {
    if (window.Turbo) {
      window.Turbo.visit(path)
    } else {
      window.location.assign(path)
    }
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    visit()
    return
  }

  const body = document.body
  body.style.transition = `opacity ${FADE_MS}ms cubic-bezier(0.2, 0.6, 0.2, 1)`
  body.style.opacity = '0'

  const reset = () => {
    body.style.transition = ''
    body.style.opacity = ''
  }
  // Turbo snapshots the page for back-button restores right before
  // rendering the next one — don't let it cache a fully transparent body.
  document.addEventListener('turbo:before-cache', reset, { once: true })
  // Safety net: a failed visit (e.g. network error) aborts before
  // turbo:before-cache ever fires — restore the page rather than leaving
  // it stuck fully transparent.
  window.setTimeout(reset, FADE_MS * 10)

  window.setTimeout(visit, FADE_MS)
}
